import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import XplorerTable from '@blade-sxp/pass/components/xplorer-table.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import { handleError } from '@blade/common/utils/handle-error';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
let default_1 = class default_1 extends Vue {
    libId;
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    whiteStaff = [];
    listLoading = false;
    params = {
        dateEnd: '',
        dateStart: '',
        keywords: '',
        personGroup: EType.USER,
        relation: true,
        sort: 'DESC',
        libId: [],
    };
    portraitsToExport = [];
    groupFilters = [];
    handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.getData();
    }
    handleCurrentChange(curr) {
        this.pagination.page = curr;
        this.getData();
    }
    handleFullScreen() {
        document.body.requestFullscreen();
    }
    handleRefresh() {
        this.getData();
    }
    handleSelectionChange(val) {
        this.portraitsToExport = val.map((item) => item.portraitId);
        console.log('this.portraitsToExport:', this.portraitsToExport);
    }
    handleCreate() {
        this.$router.push('/traffic/staff/white/staff-create');
    }
    mounted() {
        this.getGroup();
        this.getData();
        this.$refs['staff-table'] && this.$refs['staff-table'].clearSelection();
        this.params.libId.push(...this.libId);
        // console.log("lib id:", this.libId)
    }
    async getGroup() {
        const res = await StaffModule.getPortraitsGroup({ data: EType.USER, mode: 'CREATE' });
        const groups = res.data?.map((item) => {
            return { text: item.name, value: item.libId };
        });
        console.log('res:', groups);
        this.groupFilters = groups;
        // console.log("lib id:", this.libId)
    }
    async getData() {
        this.listLoading = true;
        try {
            const res = await StaffModule.getPassportraits({ ...this.params, page: this.pagination.page, size: this.pagination.size });
            // console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = this.mapId(list);
            this.pagination.total = total;
            this.listLoading = false;
            // this.setRowKey();
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    mapId(list) {
        const res = list.map((item) => {
            const mappedStaff = { id: item.portraitId, ...item };
            return mappedStaff;
        });
        return res;
    }
    handleUpload() {
        this.$router.push('/traffic/staff/white/upload');
    }
    handleEdit(row) {
        console.log('row:', row);
        this.$router.push(`/traffic/staff/white/staff-edit/${row.portraitId}`);
    }
    async handleSearch(search) {
        this.listLoading = true;
        try {
            const { keywords, ...rest } = this.params;
            const res = await StaffModule.getPassportraits({ ...rest, keywords: search, page: 1, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = list;
            this.pagination.total = total;
            this.pagination.page = 1;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    handleDelete(row) {
        console.log('row:', row);
        this.$confirm(`${this.$t('deleteUser').toString()}${row.name}?`, 'Warning', {
            confirmButtonText: this.$t('confirm').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            type: 'warning',
        })
            .then(async () => {
            try {
                await StaffModule.deletePortrait(row.portraitId);
                this.$elmessage.success({
                    message: this.$t('deleted').toString(),
                });
                this.getData();
            }
            catch (e) {
                handleError(e);
            }
        })
            .catch(() => { });
    }
    async handleExport() {
        if (!this.portraitsToExport || this.portraitsToExport.length === 0) {
            this.$elmessage(this.$t('selection').toString());
            return;
        }
        try {
            const res = await StaffModule.exportPortraits({ libraryType: 0, portraitIds: this.portraitsToExport });
            console.log('res:', window.location.protocol);
            this.$alert(this.$t('common.csv').toString(), '', {
                confirmButtonText: this.$t('common.confirm').toString(),
                callback: (action) => {
                    if (action === 'confirm') {
                        const path = process.env.NODE_ENV === 'development'
                            ? `https://bj.cluster21.xplorer.sensetime.com${res.data}`
                            : `${window.location.protocol}//${window.location.host}${res.data}`;
                        const a = document.createElement('a');
                        a.href = path;
                        a.click();
                    }
                },
            });
        }
        catch (e) { }
    }
    handleFilter(filters) {
        console.log('filters:', filters);
        this.params.libId = filters.group;
        this.getData();
    }
};
__decorate([
    Prop({ type: Array })
], default_1.prototype, "libId", void 0);
default_1 = __decorate([
    Component({
        name: 'portrait',
        components: { AuthItem, XplorerTable, InvisibleNumber },
        i18n: {
            messages: {
                'en-us': {
                    name: 'Name',
                    id: 'ID Number',
                    portrait: 'ID Portrait',
                    group: 'User Group',
                    ppl: 'Creator',
                    update: 'Update',
                    deleteUser: 'Are you sure to delete ',
                    confirm: 'OK',
                    cancel: 'Cancel',
                    deleted: 'Delete successfully',
                    selections: 'No row selected',
                },
                zh: {
                    name: '名字',
                    id: 'ID 号',
                    portrait: '证件头像',
                    group: '人员组',
                    ppl: '创建人',
                    update: '更新时间',
                    deleteUser: '确认删除 ',
                    confirm: '确认',
                    cancel: '取消',
                    deleted: '成功删除',
                    selections: '没有选择导出列',
                },
            },
        },
    })
], default_1);
export default default_1;
